import { authHeader, handleResponse } from "../helper/auth-header";

export default class IssueNumberService {
  ControllerName = "IssueNo";

  // get products
  async getproducts(brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/getproducts?brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetIssueNumbers(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetIssueNumbers`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetFromNumbers(BrandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetFromNumbers?BrandId=${BrandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CreateIssueNumber(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateIssueNumber`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetAvailableSeries(brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetAvailableSeries?brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CreateDemapping(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateDemapping`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CreateDamage(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateDamage`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
